import { useState, type FormEvent } from 'react';
import { useStore } from '@nanostores/react';
import { Banner, Button, Card, Heading, Link, Text, TextInput, VStack } from '@astryxdesign/core';
import { useNavigate, useSearchParams } from 'react-router';

import { $auth, $authPending, login } from '../stores/auth';

export function LoginPage() {
  const auth = useStore($auth);
  const pending = useStore($authPending);
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await login(email, password);
      // Return the user to whatever they were trying to reach.
      const next = params.get('next');
      await navigate(next && next.startsWith('/app') ? next : '/app', { replace: true });
    } catch {
      /* the error is already in the store and rendered below */
    }
  }

  return (
    <Card padding={4} variant="default" className="auth-card">
      <form onSubmit={onSubmit}>
        <VStack gap={3}>
          <VStack gap={0.5}>
            <Heading level={1}>Sign in</Heading>
            <Text size="sm" color="secondary">
              Manage your API keys, usage and plan.
            </Text>
          </VStack>

          {auth.error && <Banner status="error" title="Could not sign in" description={auth.error} />}

          <TextInput
            label="Email"
            type="email"
            value={email}
            onChange={setEmail}
            placeholder="you@company.com"
            isRequired
            hasAutoFocus
            width="100%"
          />
          <TextInput
            label="Password"
            type="password"
            value={password}
            onChange={setPassword}
            placeholder="••••••••••"
            isRequired
            width="100%"
          />

          <Button label="Sign in" variant="primary" type="submit" width="100%" isLoading={pending} />

          <Text size="sm" color="secondary">
            No account yet? <Link href="/register">Create one free</Link>.
          </Text>
        </VStack>
      </form>
    </Card>
  );
}
